module.exports = __webpack_public_path__ + "img/person3.36efe740.svg";